module.exports = __webpack_public_path__ + "static/media/contactQR.d798aef8.png";